import * as SelectPrimitive from '@radix-ui/react-select';
import * as React from 'react';
import { cn } from '@discover-lib/utils';
import buttonVariants, { type ButtonVariantProps } from '@discover-ui/button/variants';
import DropdownIcon from '@discover-ui/icons/dropdownIcon';

export type SelectTriggerProps = React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger> &
  ButtonVariantProps &
  DataAttributeProps;

const SelectTrigger = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Trigger>,
  SelectTriggerProps
>(({ className, children, scale = 'md', width, round, kind = 'normal', ...props }, ref) => (
  <SelectPrimitive.Trigger
    ref={ref}
    className={cn(
      buttonVariants({ scale, width, round, kind }),
      cn('justify-between gap-1 placeholder:text-muted-foreground [&>span]:line-clamp-1', className)
    )}
    {...props}>
    {children}
    <SelectPrimitive.Icon asChild>
      <DropdownIcon />
    </SelectPrimitive.Icon>
  </SelectPrimitive.Trigger>
));

SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;

export default SelectTrigger;
